import React, { useState, useEffect } from 'react';
import type { TypoVariants } from '../../index';
import { Typography } from '../../index';

export const LoadingDots = ({
    variant = 'title6',
    startFrom = 0,
    interval = 500,
}: {
    variant?: TypoVariants;
    startFrom?: number;
    interval?: number;
}) => {
    const [dots, setDots] = useState(startFrom);

    useEffect(() => {
        const currentInterval = setInterval(() => {
            setDots(prev => (prev < 3 ? prev + 1 : 0));
        }, interval);

        return () => clearInterval(currentInterval);
    }, [interval]);

    return <Typography variant={variant}>{'.'.repeat(dots)}</Typography>;
};
